import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';
import BuyerOnlyRouteMixin from 'sh-www/mixins/buyer-only-route-mixin';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class MyNetworkRoute extends Route.extend(BuyerOnlyRouteMixin) {
  @service() session;

  setupController(controller) {
    super.setupController(...arguments);

    controller.loadCostCodesTask.perform(this.session.currentUser.company);
    controller.loadStoryCodesTask.perform(this.session.currentUser.company);
    controller.loadCompanyStatisticsTask.perform(this.session.currentUser.company.id);
    controller.loadSearchResultsPageTask.perform(this.session.currentUser.company.id, controller.buildSearchParams(), 1);
    controller.loadInvitedSellersTask.perform(this.session.currentUser.company.id, 1);
    controller.loadServicesTask.perform();
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.resetSearchParams();
      controller.loadSearchResultsPageTask.cancelAll({ resetState: true });
      controller.loadCompanyStatisticsTask.cancelAll({ resetState: true });
      controller.loadCostCodesTask.cancelAll({ resetState: true });
      controller.loadStoryCodesTask.cancelAll({ resetState: true });
      controller.loadSidebar.cancelAll({ resetState: true });
      controller.loadInvitedSellersTask.cancelAll({ resetState: true });
      controller.loadServicesTask.cancelAll({ resetState: true });
    }
  }

  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/people/my-network/');
  }
}

export default MyNetworkRoute;
